import {createFileRoute, useRouter} from '@tanstack/react-router'
import {ArrowLeft} from 'lucide-react'
import {Button} from '@/components/ui/button'
import {PermitDetailBody} from '@/features/permits/PermitDetailBody'

function PermitDetailPage() {
	const {permitId} = Route.useParams()
	const router = useRouter()

	function goBack() {
		router.history.back()
	}

	return (
		<div className='container mx-auto max-w-4xl overflow-x-hidden overflow-y-auto h-full'>
			<div className='px-4 pt-4'>
				<Button variant='ghost' size='sm' onClick={goBack}>
					<ArrowLeft className='w-4 h-4 mr-2' />
					Back to Permits
				</Button>
			</div>
			<PermitDetailBody permitId={permitId} />
		</div>
	)
}

export const Route = createFileRoute('/permits/$permitId')({
	component: PermitDetailPage,
})
